import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

/**
 * Obtiene la lista de documentos asociados a una entidad del backend
 * @param {Object} params
 * @param {string} params.className Nombre de la entidad (p.ej. 'ImprovementProposal')
 * @param {number|string} params.idClassName ID de la entidad
 * @returns {Promise<Array>} Array de documentos (puede ser vacío)
 */
export async function getDocuments({ className, idClassName }) {
  if (!className || typeof idClassName === 'undefined' || idClassName === null) return [];
  try {
    const response = await getAPIResponse('/v1/document', { className, idClassName: parseInt(idClassName, 10) });
    if (!response) return [];
    // El endpoint devuelve directamente un array de documentos
    return Array.isArray(response) ? response : [];
  } catch (e) {
    return [];
  }
}
